export class FetchSuggestions {
	static readonly type = '[Suggestions List] Fetch';
	constructor(public filter: string, public context: string) {}
}
